export default __webpack_public_path__ + "static/media/drMaida.ad5e830c.png";